/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Deterministic category for an employee execution blocker.
 */
export enum EmployeeExecutionBlockerCategory {
    MISSING_CAPABILITY = 'missing-capability',
    CONFIGURATION_UNAVAILABLE = 'configuration-unavailable',
    TERMINAL_TOOL_FAILURE = 'terminal-tool-failure',
    REPEATED_TOOL_FAILURE = 'repeated-tool-failure',
    TERMINAL_OPERATION_FAILURE = 'terminal-operation-failure',
}
